import { Component, Inject, OnInit } from '@angular/core';

import { HsgModalDefault, HsgModalDefaultData, HSG_MODAL_DATA, HsgModalRef } from '@hhsg/hsg-asc';
import { ShiftBlockService } from 'src/shared/services/shift-block.service';
import { ShiftBlock } from 'src/shared/models/shift-block.model';
import { CostCenter } from 'src/shared/models/cost-center.model';
import { ImportTimeAndAttendance } from 'src/shared/models/import-time-and-attendance.model';
import { TimeAndAttendanceImportService } from 'src/shared/services/time-and-attendance-import.service';

@Component({
    selector: 'smt-import-time-and-attendance-modal',
    templateUrl: './import-time-and-attendance-modal.component.html',
    styleUrls: ['./import-time-and-attendance-modal.component.scss']
})
export class ImportTimeAndAttendanceModalComponent extends HsgModalDefault implements OnInit {
    public importedRows: ImportTimeAndAttendance[];
    public loading: boolean;

	constructor(
        private _timeAndAttendanceService: TimeAndAttendanceImportService,
        private _shiftBlockService: ShiftBlockService,
		public modalRef: HsgModalRef<HsgModalDefault>,
        @Inject(HSG_MODAL_DATA) public data: HsgModalDefaultData) { 
        super(modalRef, data); 
    }
  
    routerLink() {
        return ['/workflow/planner/'];
    }

    async ngOnInit() {
        this.loading = true;
        let data = this.data as any;
        let shiftBlock = data.shiftBlock as ShiftBlock;
        let workflowDate = data.workflowDate as string;
        let costCenter = data.costCenter as CostCenter;
        let startDate = this._shiftBlockService.getShiftBlockStartTime(shiftBlock, workflowDate).toDate();
        let endDate = this._shiftBlockService.getShiftBlockEndTime(shiftBlock, workflowDate).toDate();
        this.importedRows = await this._timeAndAttendanceService.getTimeAndAttendanceImportRawData(costCenter.id, startDate, endDate);
        this.loading = false;
    }
}
